// Central data-testid registry for the site
export const NAV = {
  root: 'nav-root',
  logo: 'nav-logo',
  home: 'nav-link-home',
  about: 'nav-link-about',
  companies: 'nav-link-companies',
  speaking: 'nav-link-speaking',
  media: 'nav-link-media',
  resources: 'nav-link-resources',
  workWithMe: 'nav-link-work-with-me',
  contact: 'nav-link-contact',
  cta: 'nav-cta-strategy-intensive',
  mobileToggle: 'nav-mobile-toggle',
  mobileDrawer: 'nav-mobile-drawer',
};

export const HOME = {
  hero: 'home-hero',
  ctaExplore: 'home-cta-explore-companies',
  ctaSpeak: 'home-cta-book-speaking',
  aboutPreview: 'home-about-preview',
  companiesGrid: 'home-companies-grid',
  timeline: 'home-founder-timeline',
  resources: 'home-resources',
  insights: 'home-insights',
};

export const FOOTER = {
  root: 'footer-root',
  newsletterInput: 'footer-newsletter-input',
  newsletterSubmit: 'footer-newsletter-submit',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  org: 'contact-org',
  kind: 'contact-kind',
  subject: 'contact-subject',
  message: 'contact-message',
  submit: 'contact-submit',
};

export const SPEAKING = {
  form: 'speaking-form',
  name: 'speaking-name',
  email: 'speaking-email',
  org: 'speaking-org',
  event: 'speaking-event',
  date: 'speaking-date',
  location: 'speaking-location',
  audience: 'speaking-audience',
  budget: 'speaking-budget',
  topic: 'speaking-topic',
  message: 'speaking-message',
  submit: 'speaking-submit',
  ctaBook: 'speaking-cta-book-toia',
};

export const WORK = {
  speakingCard: 'work-speaking-card',
  strategyCard: 'work-strategy-card',
  partnershipsCard: 'work-partnerships-card',
  ctaSpeaking: 'work-cta-book-toia',
  ctaStrategy: 'work-cta-book-strategy',
  ctaPartnerships: 'work-cta-start-conversation',
};

export const MEDIA = {
  downloadCard: (key) => `media-download-${key}`,
};

export const COMPANY = {
  card: (slug) => `company-card-${slug}`,
  visit: (slug) => `company-visit-${slug}`,
};

export const RESOURCES = {
  stanStore: 'resources-stan-store',
  strategyCta: 'resources-strategy-cta',
};

export const JOURNAL = {
  card: (slug) => `journal-card-${slug}`,
  viewAll: 'journal-view-all',
};

export const NOW = {
  root: 'now-root',
  ctaSpeaking: 'now-cta-speaking',
};

export const PARTNERS = {
  root: 'partners-root',
  ctaSpeaking: 'partners-cta-book-toia',
  ctaPartnership: 'partners-cta-partnership',
  inquiryForm: 'partners-inquiry-form',
  inquiryName: 'partners-inquiry-name',
  inquiryEmail: 'partners-inquiry-email',
  inquiryOrg: 'partners-inquiry-org',
  inquiryMessage: 'partners-inquiry-message',
  inquirySubmit: 'partners-inquiry-submit',
};
